module.exports = __webpack_public_path__ + "static/media/makeAMove_lv.9876b94e.svg";